export default __webpack_public_path__ + "content/a813034654b4ff0a0bacdf2773a25bcc.svg";